import { IQuery } from "@shared/hooks/useFirebaseData";

const trash = [
  {
    type: 'where',
    field: 'trash',
    operator: '==',
    value: false
  }
] as IQuery[];

const orderedByCreation = [
  {
    type: 'orderBy',
    field: 'createdAt',
    direction: 'desc'
  }
] as IQuery[];

export const Queries = {
  trash,
  orderedByCreation
};
